// NEURACOM i18n — Italian, English, Polish.
// Aggregator: per-language modules live in ./locales/{en,it,pl}.js.
// Auto-detect from browser, fallback to English.
import en from "./locales/en";
import it from "./locales/it";
import pl from "./locales/pl";

export const TRANSLATIONS = { en, it, pl };

export const SUPPORTED_LOCALES = ["en", "it", "pl"];

export function detectBrowserLocale() {
  if (typeof navigator === "undefined") return "en";
  const langs = navigator.languages || [navigator.language || "en"];
  for (const l of langs) {
    const code = l.toLowerCase().slice(0, 2);
    if (SUPPORTED_LOCALES.includes(code)) return code;
  }
  return "en";
}
